import { privateApi } from "@core/libs/axios/apiInstances";
import { handleResponse } from "@core/libs/axios/serviceHandler";
import { ApprovalItemSchema } from "@modules/docs/approvals/types/TApproval";
import type { TApprovalItem } from "@modules/docs/approvals/types/TApproval";
import { createLogger } from "@core/utils/logger";

const log = createLogger("docs:approvals");

// ─── Mapper (private) ─────────────────────────────────────────────────────────
function mapApprovalItem(dto: unknown): TApprovalItem {
  return log.parseWith(ApprovalItemSchema, dto, "getApprovalInfo");
}

// ─── GET ─────────────────────────────────────────────────────────────────────
export async function getApprovalInfo(
  workspaceId: string,
  projectId: string,
  approvalId: string,
  signal?: AbortSignal,
): Promise<TApprovalItem> {
  const envelope = await handleResponse<{ data: unknown }>(
    privateApi.get(
      `/documents/${workspaceId}/${projectId}/approval/${approvalId}`,
      { signal },
    ),
  );
  return mapApprovalItem(envelope);
}

// ─── POST approve (mutation — no signal) ─────────────────────────────────────
export async function approveApproval(
  workspaceId: string,
  projectId: string,
  approvalId: string,
): Promise<void> {
  await handleResponse<void>(
    privateApi.post(
      `/documents/${workspaceId}/${projectId}/approval/${approvalId}/approve`,
    ),
  );
}

// ─── POST reject (mutation — no signal) ──────────────────────────────────────
export async function rejectApproval(
  workspaceId: string,
  projectId: string,
  approvalId: string,
  rejection_reasons: string[],
): Promise<void> {
  await handleResponse<void>(
    privateApi.post(
      `/documents/${workspaceId}/${projectId}/approval/${approvalId}/reject`,
      { rejection_reasons },
    ),
  );
}
